import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import { Section, SectionLabel, SectionTitle, FadeIn } from "@/components/Section";
import { Ship, ClipboardList, Shield, Users, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { Anchor } from "lucide-react";

const services = [
  { icon: Ship, num: "01", title: "Crew Transfer Operations", desc: "Safe, scheduled personnel transport between shore base and FPSO facilities. Push-on alongside operations under Captain's manual control with FLIR gas detection protocols and ASOG environmental limits.", link: "/fleet" },
  { icon: Anchor, num: "02", title: "Platform Supply Vessel Operations", desc: "Full technical and commercial management of Platform Supply Vessels — deck cargo, bulk liquids, fuel oil, potable water, and consumables delivery to offshore installations with DP-2 station-keeping capability.", link: "/fleet" },
  { icon: ClipboardList, num: "03", title: "Vessel Management", desc: "Complete technical and operational management of the AIRCAT 35 crew transfer vessel and PSV fleet — planned maintenance, crewing, procurement, class survey coordination, and ISM compliance.", link: "/fleet" },
  { icon: Shield, num: "04", title: "ISM / MLC Compliance", desc: "Full Safety Management System with integrated Quality Management, HSE policies, and Maritime Labour Convention compliance. DOC and SMC certification through Republic of the Marshall Islands.", link: "/safety" },
  { icon: Users, num: "05", title: "Crew Development", desc: "Structured programme developing seafarers from entry-level ratings through to certified deck and engine officers with STCW qualifications.", link: "/about" },
];

const Services = () => (
  <Layout>
    <PageHero
      tag="Solutions"
      title={<>Crew transfer <span className="accent-text">solutions</span></>}
      subtitle="Fully-managed Crew Transfer Vessel and PSV operations with transparent accountability — from crew marshalling and supply logistics to offshore personnel transportation and cargo transfer."
    />

    <Section>
      <SectionLabel>Our Services</SectionLabel>
      <SectionTitle>End-to-end offshore <span className="accent-text">capability</span> — CTV & PSV</SectionTitle>
      <div className="space-y-6 mt-12">
        {services.map((svc, i) => (
          <FadeIn key={svc.title} delay={i * 0.1}>
            <Link to={svc.link} className="group flex flex-col md:flex-row gap-6 md:gap-10 p-8 md:p-10 rounded-2xl bg-card border border-border hover:border-teal/30 hover-lift">
              <div className="flex items-start gap-5 flex-shrink-0">
                <span className="text-teal/15 font-display text-5xl font-bold">{svc.num}</span>
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-teal/10 to-lime/10 flex items-center justify-center group-hover:from-teal/20 group-hover:to-lime/20 transition-colors">
                  <svc.icon className="w-6 h-6 text-teal" />
                </div>
              </div>
              <div className="flex-1">
                <h3 className="font-display text-xl text-navy tracking-tight mb-3">{svc.title}</h3>
                <p className="text-text-light font-body leading-relaxed">{svc.desc}</p>
                <div className="mt-4 flex items-center gap-2 text-teal text-[11px] font-bold tracking-[1.5px] uppercase font-body opacity-0 group-hover:opacity-100 transition-all duration-300">
                  Learn More
                  <ArrowRight className="w-3.5 h-3.5" />
                </div>
              </div>
            </Link>
          </FadeIn>
        ))}
      </div>
    </Section>

    <Section dark>
      <div className="text-center max-w-2xl mx-auto">
        <SectionLabel>Ready to Discuss?</SectionLabel>
        <SectionTitle light>Let's talk about your <span className="accent-text">requirements</span></SectionTitle>
        <FadeIn>
          <p className="text-primary-foreground/40 font-body text-lg mb-10 font-light">
            We provide tailored offshore personnel transportation solutions designed around your operational schedule and FPSO requirements.
          </p>
          <Link to="/contact" className="group inline-flex items-center gap-2.5 px-8 py-4 bg-gradient-to-r from-teal to-teal-light text-navy-deep text-[12px] font-bold tracking-[1.5px] uppercase rounded-full hover:shadow-xl hover:shadow-teal/25 transition-all duration-300 font-body">
            Get in Touch
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </FadeIn>
      </div>
    </Section>
  </Layout>
);

export default Services;
